import { render } from "./DeleteBuyer.vue?vue&type=template&id=5778579f"
import script from "./DeleteBuyer.vue?vue&type=script&lang=js"
export * from "./DeleteBuyer.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__